import React, { Fragment } from 'react';
import DocumentTemplateListBrowser from './DocumentTemplateListBrowser';
import HeaderPortal from 'components/layout/HeaderPortal';
import HeaderLinks from './header/HeaderLinks';
import Portal from '../../../../utils/portal/Portal';
import PropTypes from 'prop-types';
import { areas } from '../../../../constants/areas';
import { withAreaGetter } from '../../../../providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TEMPLATES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const onAdd = () => {
    historyContext.push(`/documentTemplates/new`);
  };

  const onAddBulk = () => {
    historyContext.push(`/documentTemplates/newBulk`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TEMPLATES} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} onAddBulk={onAddBulk} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TEMPLATES}>
        <DocumentTemplateListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};
Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};
export default withAreaGetter(Route);
